module.exports = __webpack_public_path__ + "img/training.5e1e41a0.jpg";